// extracted by mini-css-extract-plugin
export default {"title":"t7pVaqswjXeEVA1QXpoZ","subTitle":"Sb9vaibDmk8g7Hr7sT3J","termListContainer":"R0c5PcrqRWdp2sn4CptB"};